import { EventEmitter } from 'events';

EventEmitter.prototype._maxListeners = 0;

/**
 * Generic event listener registration with validation
 * @param {string} event - Event name from store's EVENTS object
 * @param {Function} callback - Callback function to execute when event fires
 */
EventEmitter.prototype.addEventListener = function (event, callback) {
	if (!this.EVENTS || !Object.values(this.EVENTS).includes(event)) {
		const storeName = this.constructor?.name || 'Store';
		console.warn(`${storeName}: Trying to add listener for unknown event '${event}'`);
		return;
	}

	this.on(event, callback);
};

/**
 * Generic event listener removal with validation
 * @param {string} event - Event name from store's EVENTS object
 * @param {Function} callback - Callback function to remove
 */
EventEmitter.prototype.removeEventListener = function (event, callback) {
	if (!this.EVENTS || !Object.values(this.EVENTS).includes(event)) {
		const storeName = this.constructor?.name || 'Store';
		console.warn(`${storeName}: Trying to remove listener for unknown event '${event}'`);
		return;
	}
	this.removeListener(event, callback);
};

export default EventEmitter;
